/* Nuvetila theme enhancements. Forms remain functional without JavaScript. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var imageButton = event.target.closest('[data-nv-photo]');
    if (imageButton) {
      var gallery = imageButton.closest('[data-nv-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-nv-main-photo]');
      if (main) {
        main.src = imageButton.getAttribute('data-nv-photo');
        main.alt = imageButton.getAttribute('data-nv-alt') || main.alt;
        main.removeAttribute('srcset');
      }
      gallery.querySelectorAll('[data-nv-photo]').forEach(function (button) {
        var selected = (button === imageButton);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }
    document.querySelectorAll('.nv-header__mobile-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('change', function (event) {
    var picker = event.target;
    if (picker.matches('[data-nv-variant-picker]')) {
      var product = picker.closest('[data-nv-product]');
      if (!product) return;
      var current = picker.options[picker.selectedIndex];
      var price = product.querySelector('[data-nv-variant-price]');
      var button = product.querySelector('[data-nv-add-to-cart]');
      if (price && current) price.textContent = current.getAttribute('data-price') || price.textContent;
      if (button && current) {
        var available = current.getAttribute('data-available') === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
    }
    if (picker.matches('[data-nv-auto-submit]') && picker.form) picker.form.submit();
  });
})();
